import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledBadgeIndex = styled.div`
  display: flex;
  background-color: ${theme.colors.purple_2};
  border-radius: 100px;
  padding: 10px;
  height: 30px;
  width: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.colors.purple};
  box-sizing: border-box;
`;
